import React from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';
import styles from './index.css';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import { Survey } from 'ThreeTerminal_pc_dynamic';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Text from './text';
import Video from './video';
import PageList from './pageList';

const LoadaMyAudio = Loadable({
    loader: () => import('./audio'),
    loading: () => {
        return <div />;
    },
});

const LoadSlides = Loadable({
    loader: () => import('../slides'),
    loading: () => {
        return <div />;
    },
});

let enableVideosPlugin = true;
let enableSlidesPlugin = true;
let enableSurveyPlugin = true;

class ArticleContent extends React.PureComponent {
    static propTypes = {
        topic: PropTypes.string,
        content: PropTypes.object,
        pluginData: PropTypes.object,
        handleSelectTxt: PropTypes.func,
    };

    getVideosPlugin = () => {
        const { content, pluginData } = this.props;

        if (content.currentPage === 0 && enableVideosPlugin && pluginData.videosPluginData) {
            pluginData.videosPluginData.map((item, index) => <Video key={index} videoinfo={item} />);
        } else {
            return null;
        }
    };

    getSlidesPlugin = () => {
        const { content, pluginData } = this.props;

        if (content.currentPage === 0 && enableSlidesPlugin && pluginData.slidesPluginData) {
            pluginData.slidesPluginData.map((item, index) => (
                <LazyLoad key={index}>
                    <LoadSlides limit={10} attachmentId={item.attachmentId} />
                </LazyLoad>
            ));
        } else {
            return null;
        }
    };

    getSurveyPlugin = () => {
        const { content, pluginData } = this.props;

        if (content.currentPage === 0 && enableSurveyPlugin && pluginData.surveyPluginData) {
            return <Survey surveyId={pluginData.surveyPluginData.attachmentId} />;
        } else {
            return null;
        }
    };

    getcontent = (type, data, index) => {
        const { topic, handleSelectTxt } = this.props;

        if (type === 'text') {
            return <Text key={index} content={data} handleMouseUp={handleSelectTxt} />;
        } else if (type === 'survey') {
            return (
                <LazyLoad key={index}>
                    <Survey surveyId={data.attachmentId} />
                </LazyLoad>
            );
        } else if (type === 'slide') {
            return (
                <LazyLoad key={index}>
                    <LoadSlides limit={10} attachmentId={data.attachmentId} />
                </LazyLoad>
            );
        } else if (type === 'video') {
            return <Video key={index} topic={topic} videoinfo={data} />;
        } else if (type === 'audio') {
            return (
                <LazyLoad key={index}>
                    <LoadaMyAudio audioinfo={data} />
                </LazyLoad>
            );
        }
    };

    render() {
        const { content } = this.props;

        /**
         * 当文章处于第一页时，需要判断文章数据是否有视频，轮播图，调查的内容数据和插件数据
         * 当内容数据没有时，以插件数据为主；内容数据存在时，则以内容数据为主
         */
        if (content.currentPage === 0) {
            enableVideosPlugin = true;
            enableSlidesPlugin = true;
            enableSurveyPlugin = true;

            content.contentList.forEach(item => {
                if (item.type === 'video') {
                    enableVideosPlugin = false;
                } else if (item.type === 'slide') {
                    enableSlidesPlugin = false;
                } else if (item.type === 'survey') {
                    enableSurveyPlugin = false;
                }
            });
        } else {
            enableVideosPlugin = false;
            enableSlidesPlugin = false;
            enableSurveyPlugin = false;
        }

        return (
            <div>
                {this.getVideosPlugin()}
                {this.getSlidesPlugin()}
                {content.contentList.map((item, index) => this.getcontent(item.type, item.data, index))}
                {this.getSurveyPlugin()}
                <NoSSR>
                    <PageList content={content} />
                </NoSSR>
                <div className={styles.end} />
            </div>
        );
    }
}

export default errorBoundary(ArticleContent);
